"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.InvoiceMetadataFormFieldsCQA = exports.InvoiceMetadataFormFields = void 0;
var ui_common_1 = require("@codametrix/ui-common");
var FieldType = ui_common_1.commonEnums.FieldType;
var DateOfService = {
    key: 'date_of_service',
    path: ['date_of_service'],
    displayName: null,
    classNames: [['invoice-meta-text-heading']],
    readonly: true,
    width: '1fr',
    fieldType: FieldType.Text,
    datetimeFormat: ui_common_1.cmxDateTime.FORMATS.DATE_OF_SERVICE,
    fallbackValue: 'Date not selected'
};
var DepartmentField = {
    key: 'department',
    path: ['department', 'name'],
    displayName: 'Department',
    classNames: [['invoice-meta-text-body']],
    readonly: true,
    width: '1fr',
    fieldType: FieldType.Text
};
var PeformingNameField = {
    key: 'performing_provider_name',
    path: ['performing_provider_name'],
    displayName: 'Performed By',
    classNames: [['invoice-meta-text-body']],
    readonly: true,
    width: '1fr',
    fieldType: FieldType.Text
};
var ProviderNameField = {
    key: 'billing_provider_name',
    path: ['billing_provider_name'],
    displayName: 'Billing provider',
    classNames: [['invoice-meta-text-body']],
    readonly: true,
    width: '1fr',
    fieldType: FieldType.Text
};
var ReferredByField = {
    key: 'referred_by',
    path: ['referring_provider_name'],
    displayName: 'Referred By',
    classNames: [['invoice-meta-text-body']],
    readonly: true,
    width: '1fr',
    fieldType: FieldType.Text
};
// These are the current form fields for the invoice metadata form in both the grade bench and code bench panel
// If these fields need to change dynamicaly then InvoiceMetadataFormFields can be added to the redux state rather than statically defined here
exports.InvoiceMetadataFormFields = [
    DateOfService,
    DepartmentField,
    PeformingNameField,
    ProviderNameField,
    ReferredByField
];
exports.InvoiceMetadataFormFieldsCQA = [
    __assign(__assign({}, DateOfService), { path: ['dateOfService'] }),
    __assign({}, DepartmentField),
    __assign(__assign({}, PeformingNameField), { path: ['performingProviderName'] }),
    __assign(__assign({}, ProviderNameField), { path: ['billingProviderName'] }),
    __assign(__assign({}, ReferredByField), { path: ['referringProviderName'] })
];
//# sourceMappingURL=invoice-metadata-form-fixtures.js.map